import { makeDataObjGenerator } from 'mocks/helpers'
import { SexEnum } from 'types/api/enums'
import { AccountRegistrationDetails } from 'types/global'
import { createGqlResponseTransformer } from 'utils/test-utils'

const defaultData: AccountRegistrationDetails = {
  birthDate: '2004-07-20',
  countryOfResidenceCode: '',
  nationalityCode: 'ITA',
  nativeGivenName: 'TestGivenName',
  nativeFamilyName: 'TestFamilyName',
  sex: SexEnum.M,
  isCountryOfResidenceUpdateable: true,
  alreadyItfCustomer: true,
}

export const createRegistrationDetails = makeDataObjGenerator(defaultData)

export const getRegistrationDetails = createGqlResponseTransformer(
  'accountPerson',
  'AccountPersonDetail',
  defaultData
)
